import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { fadeUp, stagger } from "./motion";
import { REASONS } from "../../data/site";

const BG = ["bg-[#FFE9F1]", "bg-[#E6FBF3]", "bg-[#FFF3D6]"];
const ACCENT = ["text-[#F63C8B]", "text-[#12B99B]", "text-[#E9A400]"];

export const WhyLove = () => {
  return (
    <section id="why" data-testid="why-section" className="relative bg-[#FFF7F0]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="text-center max-w-2xl mx-auto">
          <motion.span variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="eyebrow text-[#12B99B]">Why Customers Love Us</motion.span>
          <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="font-display mt-3 text-[clamp(2rem,5vw,3.75rem)] leading-[1.02] text-[#2A1620]">
            A dessert that's a <span className="font-script text-[#F63C8B]">show</span>
          </motion.h2>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }}
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {REASONS.map((r, i) => {
            const Icon = Icons[r.icon] || Icons.Star;
            return (
              <motion.div key={r.title} variants={fadeUp} data-testid={`reason-${i}`}
                className="card p-7 sm:p-8 flex flex-col items-start">
                <span className={`grid place-items-center h-14 w-14 rounded-2xl ${BG[i % 3]}`}>
                  <Icon size={26} strokeWidth={2} className={ACCENT[i % 3]} />
                </span>
                <h3 className="font-display text-xl mt-5 text-[#2A1620]">{r.title}</h3>
                <p className="mt-2 text-sm text-[#7C6A72] leading-relaxed">{r.text}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
